import * as SubscriptionFragment from "../../graphql/fragments/subscription";

export const subscriptionFromCache = (cache, id) => {
	const subscription = cache.readFragment({
		id,
		fragment: SubscriptionFragment.allFields,
	});

	return subscription;
};
